import { render, staticRenderFns } from "./AccountCreate.vue?vue&type=template&id=7f87141d&"
import script from "./AccountCreate.vue?vue&type=script&lang=ts&"
export * from "./AccountCreate.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports